__turbopack_context__.v({
  "animatedPopoverEnter": "AnimatedPopoverContent-module__WAyL7a__animatedPopoverEnter",
  "root": "AnimatedPopoverContent-module__WAyL7a__root",
  "view": "AnimatedPopoverContent-module__WAyL7a__view",
});
